
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import pdf from "vue-pdf";
import UploaderState from "@/components/NewFileUploader/NbNewUploader/UploaderState.vue";

import NbNewUploaderPdfPreviewToolbar from "@/components/NewFileUploader/NbNewUploader/NbNewUploaderPdfPreviewToolbar.vue";
import EmptyUploaderState from "@/components/NewFileUploader/NbNewUploader/UploadStates/EmptyUploaderState.vue";
import FileLimitUploaderState from "@/components/NewFileUploader/NbNewUploader/UploadStates/FileLimitUploaderState.vue";
import UploadingUploaderState from "@/components/NewFileUploader/NbNewUploader/UploadStates/UploadingUploaderState.vue";
import FileNotFormatUploaderState from "@/components/NewFileUploader/NbNewUploader/UploadStates/FileNotFormatUploaderState.vue";
import FileHasSomeErrorUploaderState from "@/components/NewFileUploader/NbNewUploader/UploadStates/FileHasSomeErrorUploaderState.vue";

const ERROR_NO_PDF_FORMAT = "notPdfFormat";
const ERROR_SIZE_LIMIT = "sizeLimit";

const CLASS = "preview";

@Component({
  components: {
    FileHasSomeErrorUploaderState,
    FileNotFormatUploaderState,
    UploadingUploaderState,
    FileLimitUploaderState,
    EmptyUploaderState,
    NbNewUploaderPdfPreviewToolbar,
    UploaderState,
    pdf,
  },
})
export default class UploaderPDFPreview extends Vue {
  @Prop() readonly file?;

  preview = {
    link: "",
    name: "",
    currentPage: 1,
    pageCount: 1,
    zoom: 100,
    minZoom: 20,
    maxZoom: 400,
  };

  get classes() {
    const { hasErrors } = this;

    return {
      [`${CLASS}_has-errors`]: hasErrors,
    };
  }

  updatePreview(payload) {
    this.preview = { ...payload };
  }

  get computedPreviewStyle() {
    const { zoomLevel } = this;

    return {
      width: zoomLevel,
    };
  }

  setFile({ link, name }: { link: string; name: string }) {
    Object.assign(this.preview, {
      link,
      name,
      currentPage: 1,
    });

    this.$forceUpdate();
  }

  setPageCount(payload) {
    this.preview.pageCount = payload;
  }

  setCurrentPage(payload) {
    this.preview.currentPage = payload;
  }

  getFileData(file) {
    return {
      name: file.name,
      link: URL.createObjectURL(file.data),
    };
  }

  @Watch("file", { deep: true, immediate: true })
  fileChanged(file) {
    if (!file) return;

    const data = this.getFileData(file);

    this.setFile(data);
  }

  get zoomLevel() {
    return `${this.preview.zoom}%`;
  }

  get hasErrors() {
    return !!this.file?.errors?.length;
  }

  get isFileFormatError() {
    return this.file?.errors?.some((err) => err.error === ERROR_NO_PDF_FORMAT);
  }

  get isFileLimitError() {
    return this.file?.errors?.some((err) => err.error === ERROR_SIZE_LIMIT);
  }

  reUpload(payload) {
    this.$emit("re-upload", payload);
  }
}
